import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface PasswordChangeRequiredGuardProps {
  children: React.ReactNode;
}

const PasswordChangeRequiredGuard = ({ children }: PasswordChangeRequiredGuardProps) => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (currentUser?.passwordChangeRequired) {
      // Usar replace: true para substituir a entrada atual no histórico
      navigate('/change-password?required=true', { replace: true });
    }
  }, [currentUser, navigate]);
  
  if (currentUser?.passwordChangeRequired) {
    return null;
  }
  
  return <>{children}</>;
};

export default PasswordChangeRequiredGuard;